/**
 * KAN-931: аккаунты мессенджера MAX кабинета.
 *
 *   GET   /api/v1/max-accounts/         - {accounts: MaxAccount[]}
 *   POST  /api/v1/max-accounts/import/  - подключение токеном -> {account}
 *   PATCH /api/v1/max-accounts/{id}/    - {enabled} -> {account}
 */
import apiClient from './client';
import { MAX_ACCOUNTS_URL } from './maxAccountsUrl';

/** Тип клиента MAX, из которого взят токен. */
export type MaxClientKind = 'android' | 'web';

export interface MaxAccount {
  id: string;
  operator_id: string | null;
  phone: string;
  first_name: string;
  last_name: string;
  enabled: boolean;
  status: string;
}

export interface MaxImportTokenFields {
  token: string;
  device_id: string;
  kind: MaxClientKind;
  /** Пустая строка или отсутствие: без прокси (поле не отправляется). */
  proxy?: string;
  operator_id?: string;
}

export const maxAccountsApi = {
  list: async (): Promise<MaxAccount[]> => {
    const response = await apiClient.get<{ accounts: MaxAccount[] }>(MAX_ACCOUNTS_URL);
    return response.data.accounts ?? [];
  },

  importToken: async (fields: MaxImportTokenFields): Promise<MaxAccount> => {
    const body: Record<string, string> = {
      token: fields.token,
      device_id: fields.device_id,
      kind: fields.kind,
    };
    const proxy = (fields.proxy ?? '').trim();
    if (proxy) body.proxy = proxy;
    if (fields.operator_id) body.operator_id = fields.operator_id;
    const response = await apiClient.post<{ account: MaxAccount }>(`${MAX_ACCOUNTS_URL}import/`, body);
    return response.data.account;
  },

  setEnabled: async (id: string, enabled: boolean): Promise<MaxAccount> => {
    const response = await apiClient.patch<{ account: MaxAccount }>(
      `${MAX_ACCOUNTS_URL}${encodeURIComponent(id)}/`,
      { enabled }
    );
    return response.data.account;
  },
};
